import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '投产需求增量',
    type: 'BRF_SYS_PRODUCTION_BRANCH',
}
